import { createContext, useContext } from 'react';

/**
 * The entity most figures on a screen belong to — a portfolio symbol, a fund
 * symbol. Wrapping a screen in <MetricScope entity={symbol}> means individual
 * numbers only have to name their metric, not repeat the entity.
 */
const MetricContext = createContext(null);

export function MetricScope({ entity, children }) {
  return <MetricContext.Provider value={entity}>{children}</MetricContext.Provider>;
}

export const useMetricEntity = () => useContext(MetricContext);
